<template>
  <div :class="[showOneMinuteWarning ? 'app-alert-error' : 'app-alert-warning']" class="timer"
       role="alert" aria-live="off">
    <img src="@ridmv/web-themes/images/icons/clock-solid.svg" alt="">
    <p>
      Time remaining to hold your appointment: <span>{{ timeRemaining }}</span>
      <span v-show="showOneMinuteWarning" ref="oneMinuteWarning" tabindex="-1">
        You have less than a minute to hold this reservation.
      </span>
    </p>
  </div>
</template>


<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { useStore } from 'vuex';
import alertUtil from '@/utils/alerts';
import { SLOTS_HOLD_DELETE } from '../../store/_commons';

// Composables
const store = useStore();

// Reactive State
const timeRemaining = ref('');
const timerId = ref(0);
const showOneMinuteWarning = ref(false);

// Template Ref
const oneMinuteWarning = ref(null);

// Computed properties
const resSlotHoldEndTime = computed(() => store.state.user.resSlotHoldEndTime);

// Watcher
watch(showOneMinuteWarning, (newVal) => {
  if (newVal) {
    nextTick(() => {
      const elem = oneMinuteWarning.value;
      if (elem) {
        elem.focus();
      }
    });
  }
});

// Methods
const removeSlotHold = () => store.dispatch(SLOTS_HOLD_DELETE);

const startTimer = () => {
  timerId.value = setInterval(updateTimer, 500);
};

const updateTimer = () => {
  const end = resSlotHoldEndTime.value;
  const now = new Date().getTime();

  if (now >= end) {
    clearInterval(timerId.value);
    timeRemaining.value = '0:00';
    removeSlotHold();
    alertUtil.showTimerExpiredModal(store); // Pass the store here
  } else {
    timeRemaining.value = formatTime((end - now) / 1000);
    showOneMinuteWarning.value = (end - now) < 60000;
  }
};

const formatTime = (time) => {
  const minutes = Number.parseInt(time / 60, 10);
  let seconds = Number.parseInt(time % 60, 10);

  seconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${minutes}:${seconds}`;
};

// Lifecycle Hooks
onMounted(() => {
  startTimer();
});

onBeforeUnmount(() => {
  clearInterval(timerId.value);
});
</script>

<style lang="scss" scoped>
.timer {
  span {
    @extend %alert-emphasis;
    ~ span {
      margin-left: 1.25em;
      @media only screen and (max-width: 1015px) {
        display: block;
        margin-left: 0;
        margin-top: 0.15em;
      }
    }
  }
}
</style>
